import React from 'react';
import { css } from 'aphrodite';
import styles from './standard-input-styles';

const StandardInput = (props) => (
  <div className={css(styles.root)}>
    <input className={css(styles.input)} placeholder={props.placeholder} onChange={props.onChange} value={props.value} disabled={props.disabled} />
  </div>
);

export default StandardInput;



// WEBPACK FOOTER //
// ./src/components/common/standard-input/standard-input.js